import React, { useEffect, createElement } from 'react';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import { LandingPage } from './pages/LandingPage';
var BUILD_VERSION = '2026-03-23-v3';
var META_PIXEL_ID = '1579514146604651';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    MP_BUILD: string;
  }
}
// Expose build version globally for debugging
if (typeof window !== 'undefined') {
  window.MP_BUILD = BUILD_VERSION;
}
function firePixelViaImage(eventName: string, params?: Record<string, any>) {
  try {
    var img = new Image(1, 1);
    var queryParams = new URLSearchParams({
      id: META_PIXEL_ID,
      ev: eventName,
      noscript: '1'
    });
    if (params) {
      Object.keys(params).forEach(function (key) {
        queryParams.set(key, String(params[key]));
      });
    }
    img.src = 'https://www.facebook.com/tr?' + queryParams.toString();
  } catch (e) {
    // silently fail
  }
}
function initMetaPixel() {
  try {
    if (typeof window === 'undefined') return;
    if (window.fbq) return;
    var n: any = window.fbq = function () {
      var args = Array.prototype.slice.call(arguments);
      if (n.callMethod) {
        n.callMethod.apply(n, args);
      } else {
        n.queue.push(args);
      }
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onerror = function () {
      firePixelViaImage('PageView');
    };
    document.head.appendChild(script);
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
    firePixelViaImage('PageView');
  } catch (e) {
    firePixelViaImage('PageView');
  }
}
export function trackPixelEvent(eventName: string, params?: Record<string, any>) {
  try {
    if (window.fbq) {
      window.fbq('track', eventName, params);
    }
    firePixelViaImage(eventName, params);
  } catch (e) {
    firePixelViaImage(eventName, params);
  }
}
export { BUILD_VERSION };
// Diagnostic mode: ?diagnostic renders minimal page to test WebView
function isDiagnostic(): boolean {
  try {
    return window.location.search.indexOf('diagnostic') !== -1;
  } catch (e) {
    return false;
  }
}
function DiagnosticPage() {
  return createElement('div', {
    style: {
      background: '#0f1724',
      color: '#22d3ee',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Inter, sans-serif',
      padding: '20px',
      textAlign: 'center' as const
    }
  }, createElement('div', null, createElement('h1', {
    style: {
      color: 'white',
      fontSize: '2rem',
      marginBottom: '16px'
    }
  }, 'DIAGNOSTIC OK'), createElement('p', {
    style: {
      fontSize: '1rem',
      marginBottom: '8px'
    }
  }, 'Build: ' + BUILD_VERSION), createElement('p', {
    style: {
      fontSize: '0.875rem',
      color: '#94a3b8'
    }
  }, 'UA: ' + (typeof navigator !== 'undefined' ? navigator.userAgent : 'N/A')), createElement('p', {
    style: {
      fontSize: '0.875rem',
      color: '#4ade80',
      marginTop: '16px'
    }
  }, 'Si ves esto, React funciona en tu navegador.')));
}
export function App() {
  useEffect(function () {
    var timer = setTimeout(function () {
      initMetaPixel();
    }, 1500);
    return function () {
      clearTimeout(timer);
    };
  }, []);
  // Diagnostic mode bypasses everything
  if (isDiagnostic()) {
    return createElement(DiagnosticPage, null);
  }
  return <ErrorBoundary data-id="element-0">
      <LandingPage data-id="element-1" />
    </ErrorBoundary>;
}